var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"value":_vm.loader,"light":"","z-index":_vm.options.zIndex}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":_vm.options.color,"size":60,"width":6}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }